var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCheckmarkFilledGray = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9EACB0",
    fillRule: "evenodd",
    cx: 10,
    cy: 10,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.2,
    d: "m6.222 9.834 2.808 3.277 4.526-6.667",
    fillRule: "evenodd",
    stroke: "#F0F4F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCheckmarkFilledGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-checkmark-filled-gray.4324c9b0de32416db3b1dc3ba7b5d8f3.svg";